import BootstrapVue from 'bootstrap-vue'

const BOOTSTRAP_CONFIG = {
  BTable: {
    labelSortAsc: null,
    labelSortDesc: null,
    labelSortClear: null,
    sortDirection: null,
  },
  BPagination: {
    labelFirstPage: 'first_page',
    labelLastPage: 'last_page',
    labelNextPage: 'next_page',
    labelPrevPage: 'prev_page',
  },
}

export const useBootstrapPlugin = (instance) => {
  instance.use(BootstrapVue, BOOTSTRAP_CONFIG)
}
